import React, { memo } from 'react'
import { useRef } from 'react'
import { useSelector } from 'react-redux'

function Card({ isLeft, isFlipped, updateFlip, r_flipped, l_flipped, option, inputRef, handleTextChange, updateOptionImage, image, removeOptionImage, default_image_url }) {

   const { modalOpen: previewModalOpen } = useSelector(state => state.preview)
   const inputTextRef = useRef(null)
   const handleIconClick = () => {
      isLeft ? updateFlip(true, r_flipped) : updateFlip(l_flipped, true)
    inputTextRef.current !== null &&  inputTextRef.current.focus()
   }

   const onInputChange = (e) => isLeft ? handleTextChange({ l_option: e.target.value }) : handleTextChange({ r_option: e.target.value })

   const onImageChange = (e) => isLeft ? updateOptionImage(e, { isLeft: true }) : updateOptionImage(e, { isLeft: false })
   const onImageRemove = () => isLeft ? removeOptionImage({ isLeft: true }) : removeOptionImage({ isLeft: false })
   const handleFocus = (event) => event.target.select();

   return (
      <div className={isLeft ? 'card card-left' : 'card'} >
         <div className="card-inner" id={isFlipped ? 'flipped' : ''} >
            <div className="card-front">
               <div className='icon-container' onClick={() => handleIconClick()}>
                  <img src='/assets/icons/edit-card.svg' />
               </div>
               {/* <img src='/assets/icons/duonut-logo.svg' className='logo' /> */}
               <div className='rectangle'></div>
               <div className='rectangle rectangle-inner'></div>
            </div>
            <div className="card-back" style={{ backgroundColor: image !== undefined ? 'transparent' : '#FBFBF7', ...(previewModalOpen && { justifyContent: 'center' }) }} >
               {
                  image !== undefined ?
                     <>
                        <img src={image.uri} className='card-image' />
                        <div className="card-image-remove-btn" onClick={onImageRemove} >
                           <img src='/assets/icons/cross-icon.svg' />
                        </div>
                     </>
                     :
                     default_image_url !== null && default_image_url !== undefined ?
                        <>
                           <img src={default_image_url} className='card-image' />
                           <div className="card-image-remove-btn" onClick={onImageRemove} >
                              <img src='/assets/icons/cross-icon.svg' />
                           </div>
                        </>
                        :
                        <>
                           <div className='input-container'>
                              <input placeholder='Add Text'
                                 value={option}
                                 ref={inputTextRef}
                                 disabled={previewModalOpen ? true : false}
                                 onFocus={handleFocus}
                                 onChange={e => e.target.value.length < 20 && onInputChange(e)} />
                           </div>
                           <div className='or-text'>
                              or
                           </div>
                           <div className='btn-container'>
                              <button onClick={() => inputRef.current.click()}>
                                 <span>
                                    upload image
                                 </span>
                              </button>
                              <input type="file" ref={inputRef}
                                 onChange={(e) => onImageChange(e)} accept="image/*" style={{ display: "none" }} />
                           </div>
                        </>
               }

            </div>
         </div>
      </div>
   )
}

export default memo(Card)